<template>
  <input
    :value="modelValue"
    @input="OnInput"
    :type="type"
    :placeholder="placeholder"
    :readonly="readonly"
    :class="[
      variants[variant].classes,
      variants[variant].default,
      variants[variant].selected,
      sizes[size],
      fontSizes[size],
      block && 'block',
      full && 'w-full',
      fontMono && 'font-mono',
    ]"
  />
</template>

<script setup lang="ts">
import { Ref, ref } from "vue";

//Types
import type { SizesKeysType } from "@/types/sizes.type";
import { SizesKeys } from "@/types/sizes.type";

//Component types & definitions
import {
  VariantKeys,
  VariantsType,
  variants,
  sizes,
  fontSizes,
} from "./Input";
import { Types } from "./Input";

withDefaults(
  defineProps<{
    type?: keyof typeof Types;
    modelValue?: string | number | Date;
    variant?: VariantsType;
    size?: SizesKeysType;
    block?: boolean;
    full?: boolean;
    placeholder?: string;
    required?: boolean;
    readonly?: boolean;
    disabled?: boolean;
    min?: number;
    max?: number;
    fontMono?: boolean;
  }>(),
  {
    type: Types.text,
    modelValue: "",
    variant: VariantKeys.primary,
    size: SizesKeys.default,
    block: false,
    full: true,
    fontMono: false,
  }
);

const timer: Ref<ReturnType<typeof setTimeout> | null> = ref(null);

const emit = defineEmits<{
  (e: "FinishTyping", ev: Event): void;
  (e: "update:modelValue", value: string): void;
  (e: "input", ev: Event): void;
}>();

const OnInput = (ev: Event) => {
  emit("update:modelValue", (ev?.target as HTMLInputElement).value);
  emit("input", ev);
  timer.value && clearTimeout(timer.value);
  timer.value = setTimeout(() => {
    emit("FinishTyping", ev);
  }, 400);
};
</script>
